import type { Sprite, Text } from 'pixi.js';
import { CountDownFormat, formatIntoUnitCountdown, MS_IN_DAY, MS_IN_HOUR, MS_IN_MINUTE } from 'utils/time-utils';
import { getLocalizedValue } from '@softgames/localization';
import { InventoryItem } from '../../../app/resources/types';

const inventoryTextureMap: Record<InventoryItem, string> = {
  [InventoryItem.Coin]: 'Big_Coin_Icon',
  [InventoryItem.BoosterRedraw]: 'Swap_Booster',
  [InventoryItem.BoosterHammer]: 'Hammer_Booster',
  [InventoryItem.BoosterMove]: 'Move_Booster',
  [InventoryItem.UnlimitedLivesMinutes]: 'Reward_Infinite_Lives',
  [InventoryItem.Lives]: 'Reward_Life',
  [InventoryItem.BoosterUndo]: 'Undo_Booster',
  [InventoryItem.FreeSpin]: 'Lucky_Wheel_Item_Icon',
};

export function setIconForInventory(
  sprite: Sprite & { data?: { maxSize?: number } },
  item: InventoryItem,
  iconOverride: Partial<Record<InventoryItem, string | null>> = {},
): Sprite {
  const maxSize = sprite?.data?.maxSize ?? null;

  sprite.props({
    texture: iconOverride[item] ?? inventoryTextureMap[item],
  });

  if (maxSize !== null) {
    sprite.width = maxSize;
    sprite.height = maxSize;
    sprite.scale.set(Math.min(sprite.scaleX, sprite.scaleY));
  }

  return sprite;
}

export function formatAmountForInventory(text: Text, item: InventoryItem, amount: number): Text {
  if (item === InventoryItem.UnlimitedLivesMinutes) {
    text.text = formatIntoUnitCountdown(amount * MS_IN_MINUTE, 1, CountDownFormat.DHM);
  } else {
    text.text = `x${getLocalizedValue(amount)}`;
  }

  return text;
}

export function formatInventoryCountdown(timerText: Text, endDate: number): void {
  const remainingTime = endDate - Date.now();

  if (remainingTime < 0) {
    timerText.text = '---';
    return;
  }

  if (remainingTime < MS_IN_HOUR) {
    timerText.text = formatIntoUnitCountdown(remainingTime, 2, CountDownFormat.HMS);
    return;
  }

  if (remainingTime < MS_IN_DAY) {
    timerText.text = formatIntoUnitCountdown(remainingTime, 2, CountDownFormat.HM);
    return;
  }

  timerText.text = formatIntoUnitCountdown(remainingTime, 2, CountDownFormat.DH);
}
